// extracted by mini-css-extract-plugin
export default {"device":"index_device__gGUaq","box":"index_box__qfXo9"};